// eslint-disable-next-line import/prefer-default-export
export const listApplications = /* GraphQL */ `
    query ListApplications(
        $id: ID
        $filter: ModelApplicationFilterInput
        $limit: Int
        $nextToken: String
        $sortDirection: ModelSortDirection
    ) {
        listApplications(
            id: $id
            filter: $filter
            limit: $limit
            nextToken: $nextToken
            sortDirection: $sortDirection
        ) {
            items {
                id
                festival {
                    id
                    name
                }
                form {
                    id
                    name
                }
                instrument {
                    id
                    slug
                    name
                    order
                }
                student {
                    id
                    name {
                        first
                        last
                    }
                    grade
                    school {
                        name {
                            legal
                        }
                        zone {
                            name
                        }
                    }
                }
                teacher {
                    id
                    name {
                        first
                        last
                    }
                }
                ranking {
                    local
                    score
                }
                selection {
                    part
                    ranking {
                        state
                    }
                    ensemble {
                        name
                    }
                }
                createdAt
                updatedAt
            }
            nextToken
        }
    }
`;

export const listInstruments = /* GraphQL */ `
    query ListInstruments(
        $id: ID
        $filter: ModelInstrumentFilterInput
        $limit: Int
        $nextToken: String
        $sortDirection: ModelSortDirection
    ) {
        listInstruments(
            id: $id
            filter: $filter
            limit: $limit
            nextToken: $nextToken
            sortDirection: $sortDirection
        ) {
            items {
                id
                slug
                name
                order
                createdAt
                updatedAt
                formInstrumentsId
            }
            nextToken
        }
    }
`;
